import React from "react";

export default function MentionsLegales() {
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <header className="space-y-2">
        <h2 className="text-3xl font-semibold text-site">Mentions légales</h2>
        <p className="text-site-soft text-sm md:text-base">
          Cette page est une maquette. Les informations qui suivent sont placées
          ici à titre d&apos;exemple et devront être remplacées par de vraies
          mentions légales si le projet devient public.
        </p>
      </header>

      <section className="card shadow-sm p-6 space-y-2 text-sm text-site-soft">
        <p>
          <span className="font-semibold text-site">Éditeur du site :</span>{" "}
          Projet MixMind (vitrine, non commercialisé).
        </p>
        <p>
          <span className="font-semibold text-site">Hébergement :</span> à
          définir (exemple : plateforme d&apos;hébergement web européenne).
        </p>
        <p>
          <span className="font-semibold text-site">Responsabilité :</span> le
          contenu de ce site est purement démonstratif et n&apos;a pas vocation
          à fournir des conseils définitifs, qu&apos;ils soient techniques,
          éducatifs ou juridiques.
        </p>
      </section>
    </div>
  );
}
